<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Playoffs</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>
        <div class="mb-3"></div>
        <playoffs-grid></playoffs-grid>
    </div>
</template>

<script>
import PlayoffsGrid from './PlayoffsGrid.vue'

export default {
    components: {
        PlayoffsGrid
    }
}
</script>

<style></style>
